// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#initForm {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
}

#initFormContainer {
	display: flex;
	flex-direction: column;
	background-color: white;
	min-width: 30%;
}

#initFormHeader {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #f0f0f0;
	padding: 2vh;
}

#initFormContent {
	display: flex;
	flex-direction: column;
	padding: 2vhpx;
}

.initFormQuestion{
	display: flex;
	flex-direction: row;
	flex: 1;
	align-items: center;
	padding: 2vh;
}

.initFormText {
	min-width: 175px;
}

.initFormError {
	color: red;
}

.initFormValue{
    width: 100%;
	display: flex;
    justify-content: end;
}

.initFormSelect {
	min-width: 20vh;
	min-height: 3vh;
}

.initFormInput {
	width: 19vh;
	min-height: 2vh;
}

.initFormButton{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f8f8f8;
    padding: 1vh;
    border: 1px solid grey;
    border-radius: 4px;
    margin: 1vh;
	min-width: 10vh;
}
.initFormButton:hover{
	background-color: #e0e0e0;
	cursor: pointer;
}

#initFormFooter {
	display: flex;
	justify-content: end;
	align-items: center;
	background-color: #f0f0f0;
	padding: 2vh;
}`, "",{"version":3,"sources":["webpack://./src/project/css/initform.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,oCAAoC;CACpC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,OAAO;CACP,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;IACI,WAAW;CACd,aAAa;IACV,oBAAoB;AACxB;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;CACd,eAAe;AAChB;AACA;CACC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,oBAAoB;CACpB,mBAAmB;CACnB,yBAAyB;CACzB,YAAY;AACb","sourcesContent":["#initForm {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground-color: rgba(0, 0, 0, 0.5);\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n#initFormContainer {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tbackground-color: white;\r\n\tmin-width: 30%;\r\n}\r\n\r\n#initFormHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tbackground-color: #f0f0f0;\r\n\tpadding: 2vh;\r\n}\r\n\r\n#initFormContent {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tpadding: 2vhpx;\r\n}\r\n\r\n.initFormQuestion{\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tflex: 1;\r\n\talign-items: center;\r\n\tpadding: 2vh;\r\n}\r\n\r\n.initFormText {\r\n\tmin-width: 175px;\r\n}\r\n\r\n.initFormError {\r\n\tcolor: red;\r\n}\r\n\r\n.initFormValue{\r\n    width: 100%;\r\n\tdisplay: flex;\r\n    justify-content: end;\r\n}\r\n\r\n.initFormSelect {\r\n\tmin-width: 20vh;\r\n\tmin-height: 3vh;\r\n}\r\n\r\n.initFormInput {\r\n\twidth: 19vh;\r\n\tmin-height: 2vh;\r\n}\r\n\r\n.initFormButton{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #f8f8f8;\r\n    padding: 1vh;\r\n    border: 1px solid grey;\r\n    border-radius: 4px;\r\n    margin: 1vh;\r\n\tmin-width: 10vh;\r\n}\r\n.initFormButton:hover{\r\n\tbackground-color: #e0e0e0;\r\n\tcursor: pointer;\r\n}\r\n\r\n#initFormFooter {\r\n\tdisplay: flex;\r\n\tjustify-content: end;\r\n\talign-items: center;\r\n\tbackground-color: #f0f0f0;\r\n\tpadding: 2vh;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
